
function isTouchScreenDevice (){
    try{
        document.createEvent('TouchEvent');
        return true;
    }catch(e){
        return false;
    }
}
export function SetProperLayout(){
    if (isTouchScreenDevice()){  
        document.documentElement.style.setProperty('--font-size', "1.35vw");
        // document.documentElement.style.setProperty('--max-width', window.outerWidth+'px');
        document.documentElement.style.setProperty('--min-width', window.outerWidth+'px');
    }else{
        // let maxWidth = window.devicePixelRatio !== 1 ? window.outerWidth - 75 : 1900;
        document.documentElement.style.setProperty('--font-size', "12px");
        // document.documentElement.style.setProperty('--max-width', maxWidth+"px");
        document.documentElement.style.setProperty('--min-width', 780+"px");

        // document.documentElement.style.setProperty('--min-width', 1015/window.devicePixelRatio+"px");
    }
}